import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import Button from 'shared/components/button/Button';
import JokerWizIcon from 'shared/components/icon/JokerWiz';
import Locked from 'shared/components/icon/Locked';
import * as Text from 'shared/utils/Text';

import styles from './index.module.scss';

const JokerwizButton = ({ onClick, upgradeRequired }) => (
  <div className={styles.root}>
    <JokerWizIcon className={styles.icon} />

    <div className={styles.text}>
      <div className={styles.header}>{Text.get('jokerwiz-explain-header')}</div>
      <div className={styles.details}>
        {Text.get('jokerwiz-explain-details')}

        <Link to="/om-wiz" className={styles.link}>
          {Text.get('jokerwiz-explain-link')}
        </Link>
      </div>
    </div>

    <Button className={styles.button} onClick={onClick}>
      <div className={styles.buttonInner}>
        {upgradeRequired && (
          <>
            <Locked className={styles.lock} />
            {Text.get('jokerwiz-dialog-systems-upgrade')}
          </>
        )}
        {!upgradeRequired && Text.get('jokerwiz-dialog-systems-start')}
      </div>
    </Button>
  </div>
);

JokerwizButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  upgradeRequired: PropTypes.bool.isRequired,
};

export default JokerwizButton;
